import axios from 'axios'

import { standSPE } from '@/core/types.js'
import Section from '@/hobjects/Section.js'
import Surface from '@/hobjects/Surface.js'
import Generic from '@/hobjects/Generic.js'
import Activator from '@/hobjects/Activator.js'
import Land from '@/hobjects/Land.js'
import OrionTower from '@/hobjects/OrionTower.js'
import Hangar01 from '@/hobjects/Hangar01.js'
import Pavilion from '@/hobjects/Pavilion.js'
import StandFiladelfia from '@/hobjects/StandFiladelfia.js'
import StandMarsella from '@/hobjects/StandMarsella.js'
import StandAlejandria from '@/hobjects/StandAlejandria.js'
import StandBabilonia from '@/hobjects/StandBabilonia.js'
import StandMileto from '@/hobjects/StandMileto.js'
import OfficeR06SY from '@/hobjects/OfficeR06SY.js'
import OfficeR05 from '@/hobjects/OfficeR05.js'
import OfficeR06 from '@/hobjects/OfficeR06.js'
import SangYongHall from '@/hobjects/SangYongHall.js'
import SilverTotem from '@/hobjects/SilverTotem.js'
import SilverBannerPodium from '@/hobjects/SilverBannerPodium.js'
import HApp from '@/core/HApp.js'
import ENV from 'ENV'

// import { EventBus } from '@/js/EventBus.js'

// import { store } from '@/store'

export default class HScene {
  constructor() {
    this.hApps = []
    this.hObjectsRegisterQueue = []
    this.activators = []
    this.token = JSON.parse(sessionStorage.getItem('token'))
  }

  fetchHApps (dimension) {
    axios({
      method: 'GET',
      'url': `${ENV.server_back}/api/happs/dimension/${dimension}`,
      'headers': {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then(result => {
      // console.log('Respuesta del servidor')
      // console.log(result.data)
      // hApps = result.data

      for (var i = 0; i < result.data.length; i++) { // Recorriendo todos los hApps de la consulta
        let happ = new HApp(result.data[i].name)

        happ.id = result.data[i].id

        happ.text = result.data[i].name
        happ.value = result.data[i].name

        happ.registered = false

        happ.user_id = result.data[i].user_id
        happ.user_email = ''
        happ.dimension_id = result.data[i].dimension_id
        happ.dimension = dimension

        happ.content = JSON.parse(result.data[i].content)

        for (let key in happ.content.hObjects) {
          happ.content.hObjects[key].registered = false
        }

        // store.state.hScene.registerHApp(happ)
        window.hScene.registerHApp(happ)
      }
    }, error => {
      console.error(error)
    })
  }

  putHApp (hApp) {
    let hAppServer = { ...hApp } // Se hace una copia para modificar ya que el valor se está pasando por referencia
    hAppServer.content = JSON.stringify(hAppServer.content)
    hAppServer.dimension = window.dimension
    this.token = JSON.parse(sessionStorage.getItem('token'))
    axios({
      method: 'PUT',
      'url': `${ENV.server_back}/api/happs/${hApp.id}`,
      'data': JSON.stringify(hAppServer),
      'headers': {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': this.token.token_type + ' ' + this.token.access_token
      }
    }).then(result => {
      console.log('Actualizado')
    }, error => {
      console.error(error)
    })
  }

  postHApp (hApp) {
    let hAppServer = { ...hApp } // Se hace una copia para modificar ya que el valor se está pasando por referencia
    hAppServer.content = JSON.stringify(hAppServer.content)
    hAppServer.dimension = window.dimension
    this.token = JSON.parse(sessionStorage.getItem('token'))
    console.log('HScene postHApp')
    console.log(hApp)
    axios({
      method: 'POST',
      'url': `${ENV.server_back}/api/happs`,
      'data': JSON.stringify(hAppServer),
      'headers': {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': this.token.token_type + ' ' + this.token.access_token
      }
    }).then(result => {
      console.log('Guardado como nuevo')
      hApp.id = result.data.id // Se actualiza el id del hApp que se pasa por referencia
      this.hApps[hApp.name].id = result.data.id // Se actualiza el id del hApp del array general
    }, error => {
      console.error(error)
    })
  }

  registerHApp (hApp) {
    if (!hApp.registered && hApp.dimension === window.dimension) {
      hApp.registered = true
      this.hApps[hApp.name] = hApp
      this.registerHObjects(hApp)
    }
  }

  registerHObjects (hApp) {
    for (let key in hApp.content['hObjects']) {
      this.registerHObject(hApp.content['hObjects'][key])
    }
    // console.log(JSON.stringify(hApp))
  }

  unRegisterHObjects (hApp) {
    for (let key in hApp.content['hObjects']) {
      this.unRegisterHObject(hApp.content['hObjects'][key])
    }
    // console.log(JSON.stringify(hApp))
  }

  registerHObject (hObject, force = false) {
    // Si el objeto permite ser registrado y no está registrado
    if ((hObject.allowRegistration && !hObject.registered) || force) {
      // let hApp = this.hApps[hObject.hAppName]

      switch (hObject.type) {
        case 'Section':
          hObject = new Section(hObject)
          hObject.register()
          break
        case 'Surface':
          hObject = new Surface(hObject)
          hObject.register()
          break
        case 'Pavilion':
          hObject = new Pavilion(hObject)
          hObject.register()
          break
        case 'StandFiladelfia':
          hObject = new StandFiladelfia(hObject)
          hObject.register()
          break
        case 'StandMarsella':
          hObject = new StandMarsella(hObject)
          hObject.register()
          break
        case 'StandAlejandria':
          hObject = new StandAlejandria(hObject)
          hObject.register()
          break
        case 'StandBabilonia':
          hObject = new StandBabilonia(hObject)
          hObject.register()
          break
        case 'StandMileto':
          hObject = new StandMileto(hObject)
          hObject.register()
          break
        case 'OrionTower':
          hObject = new OrionTower(hObject)
          hObject.register()
          break
        case 'exteriores':
          hObject = new Land(hObject)
          hObject.register()
          break
        case 'stand_SPE':
          standSPE(hObject)
          break
        case 'Hangar01':
          hObject = new Hangar01(hObject)
          hObject.register()
          break
        case 'SangYongHall':
          hObject = new SangYongHall(hObject)
          hObject.register()
          break
        case 'OfficeR05':
          hObject = new OfficeR05(hObject)
          hObject.register()
          break
        case 'OfficeR06':
          hObject = new OfficeR06(hObject)
          hObject.register()
          break
        case 'OfficeR06SY':
          hObject = new OfficeR06SY(hObject)
          hObject.register()
          break
        case 'SilverTotem':
          hObject = new SilverTotem(hObject)
          hObject.register()
          break
        case 'SilverBannerPodium':
          hObject = new SilverBannerPodium(hObject)
          hObject.register()
          break
        case 'Activator':
          hObject = new Activator(hObject)
          // hObject.register()
          // this.activators.push({hApp, hObject})
          break
        default:
          hObject = new Generic(hObject)
          hObject.register()
      }
    }

    console.log('this.hApps')
    console.log(this.hApps)
    console.log('hObject.hAppName')
    console.log(hObject.hAppName)
    // Se asigna el nuevo hObject específico al hObject inicial que era solo JSON
    this.hApps[hObject.hAppName].addHObject(hObject)

    return hObject
  }

  unRegisterHObject (hObject, force = false) {
    hObject.allowRegistration = hObject.allowRegistrationDefault // Se restablece el valor por defecto
    if (hObject.registered || force) {
      let hApp = this.hApps[hObject.hAppName]

      hObject.registered = false

      var objs = window.scene.getMeshesByTags(hApp.name + '.' + hObject.name)

      for (var i = 0; i < objs.length; i++) {
        objs[i].dispose()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/HScene.js